import { IResponse } from '@types';
import { httpClient } from '../http-client';

export const saveBanner = async (payload): Promise<IResponse<{ content: string; name: string }>> => {
  const response = await httpClient.post<IResponse<{ content: string; name: string }>>(`banner`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

export const getBanner = async (): Promise<IResponse<{ photo: string; enabled: boolean }>> => {
  const response = await httpClient.get<IResponse<{ photo: string; enabled: boolean }>>(`banner/info`);
  return response.data;
};
